import { FEATURE_FLAGS, type FeatureFlagKey } from '@/configs/featureFlags';
import { STACK_ENV, type StackEnvironment } from '@/configs/stackEnvironment';
import { getRuntimeStackEnvironment, getRuntimeTenantAlias } from '@/runtimeConfig';

export type FeatureFlagDefinition = {
  description?: string;
  enabledStacks: StackEnvironment[];
  // Omit to enable for every tenant on the enabled stacks.
  enabledTenants?: string[];
  tenantOverrides?: Record<string, boolean>;
};

export function isFeatureEnabled(flagKey: FeatureFlagKey): boolean {
  const definition = FEATURE_FLAGS[flagKey] as FeatureFlagDefinition;
  const runtimeStackEnvironment = getRuntimeStackEnvironment();
  const stackEnvironment = (runtimeStackEnvironment as StackEnvironment) ?? STACK_ENV.ProdStack;
  const tenantAlias = getRuntimeTenantAlias() ?? 'nile';

  return (
    definition.enabledStacks.includes(stackEnvironment) &&
    (!definition.enabledTenants || definition.enabledTenants.includes(tenantAlias))
  );
}
